import React, { useState } from 'react';
import { Select } from 'antd';

function SelectTimezone({ TimezoneList, onSelectTimezone, selectedZone, required = false, height, fontSize = '13px', disabled = false }) {
    const [searchText, setSearchText] = useState('');

    const options = (TimezoneList ?? []).map(tz => ({
        label: tz?.displayText ?? '',
        value: tz?.name ?? '',
        item: tz,
    }));

    return (
        <Select
            showSearch
            allowClear
            disabled={disabled}
            placeholder="Select Timezone"
            value={selectedZone || undefined}
            options={options}
            size="middle"
            style={{ width: '100%', fontSize, height: height ?? '40px' }}
            styles={{ popup: { root: { fontSize } } }}
            filterOption={(input, option) =>
                (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
            }
            filterSort={(a, b) => {
                if (!searchText) return 0;
                const lower = searchText.toLowerCase();
                const idxA = (a.label ?? '').toLowerCase().indexOf(lower);
                const idxB = (b.label ?? '').toLowerCase().indexOf(lower);
                return idxA - idxB;
            }}
            onSearch={setSearchText}
            onChange={(val, option) => {
                setSearchText('');
                onSelectTimezone(val !== undefined && val !== null ? option?.item : null);
            }}
        />
    );
}

export default SelectTimezone;
